var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bar"},[_c('div',{staticClass:"barTitle"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,style:({
        width: _vm.countWidth(index),
        color: _vm.indexA == index ? '#083875' : '#000000',
        textAlign: _vm.countAlign(index),
      }),on:{"click":function($event){return _vm.toLink(item.url, index)}}},[_vm._v(" "+_vm._s(item.name)+" "),(_vm.list.length != index + 1)?_c('span'):_vm._e()])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }